import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollIndicatorComponent } from './scroll-indicator.component';
import { LayoutRowModule } from '../../directives/layout-row/layout-row.module';
import { MatIconModule } from '@angular/material/icon';
import { AppModule } from '@caslink/device-client/ng-app/module';


@NgModule({
    declarations: [
        ScrollIndicatorComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
        LayoutRowModule,
        AppModule
    ],
    exports: [
        ScrollIndicatorComponent
    ]
})
export class ScrollIndicatorModule {
}
